import { capabilities } from '@homevest/utils'

const { ENGINEER, LEASING_ADMIN, VACANCY_READINESS_MANAGER } = capabilities.CAPABILITY_TYPES

type AdminWithCapabilities = {
  capabilities?: Array<{ type: string }>
} | null

export const hasCapability = (
  admin: AdminWithCapabilities | undefined,
  capabilityType: string
): boolean => Boolean(admin?.capabilities?.some((cap) => cap.type === capabilityType))

export const canAccessLegacyConstruction = (admin: AdminWithCapabilities | undefined): boolean =>
  hasCapability(admin, ENGINEER)

export const canAccessVacancyReadiness = (admin: AdminWithCapabilities | undefined): boolean =>
  [ENGINEER, LEASING_ADMIN, VACANCY_READINESS_MANAGER].some((type) => hasCapability(admin, type))
